import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { api, brl } from "../../lib/api";
import { MapPin } from "@phosphor-icons/react";

const BR_CENTER = [-22.918, -46.821]; // Itatiba SP roughly
const COLORS = ["#0A0A0A", "#DDA7A5", "#7B9D7E", "#E2B77B", "#C5A566"];

export default function AdminHeatmap() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try { setData((await api.get("/heatmap/points")).data); } catch {}
    })();
  }, []);

  if (!data) return <div className="text-sm tracking-widest uppercase text-[#5C5A57]">Carregando mapa...</div>;

  const points = data.points || [];
  const cities = data.cities || [];
  const maxSales = Math.max(1, ...points.map((p) => p.sales));

  return (
    <div data-testid="admin-heatmap-page">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Inteligencia geografica</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Mapa de Vendas</h1>
        </div>
        <div className="text-xs text-[#5C5A57]">{points.length} pontos GPS · {cities.length} cidades</div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 border border-[#EBE5DF] bg-white">
          <div style={{ height: 520 }}>
            <MapContainer center={BR_CENTER} zoom={5} style={{ width: "100%", height: "100%" }} data-testid="heatmap-leaflet">
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; OpenStreetMap'
              />
              {points.map((p, i) => (
                <CircleMarker
                  key={i}
                  center={[p.lat, p.lng]}
                  radius={6 + 14 * (p.sales / maxSales)}
                  pathOptions={{ color: "#0A0A0A", fillColor: "#DDA7A5", fillOpacity: 0.7, weight: 2 }}
                >
                  <Tooltip>{p.sales} venda(s) · {brl(p.total)}</Tooltip>
                  <Popup>
                    <div style={{ fontSize: 13 }}>
                      <strong>{p.sales} venda(s)</strong><br />
                      Total {brl(p.total)}<br />
                      {p.unique_clients} cliente(s)
                    </div>
                  </Popup>
                </CircleMarker>
              ))}
            </MapContainer>
          </div>
        </div>

        <div className="border border-[#EBE5DF] bg-white p-6">
          <h2 className="section-title mb-4 flex items-center gap-2"><MapPin size={18} weight="duotone" /> Cidades</h2>
          <div className="space-y-3">
            {cities.slice(0, 12).map((c, i) => (
              <div key={c.label} className="flex items-center justify-between border-b border-[#EBE5DF] pb-3 last:border-0">
                <div>
                  <div className="text-sm font-medium">{c.label}</div>
                  <div className="text-xs text-[#5C5A57]">{c.clients} cliente(s)</div>
                </div>
                <div className="tabular text-sm font-bold">{brl(c.total_sold)}</div>
              </div>
            ))}
            {cities.length === 0 && <div className="text-xs text-[#5C5A57]">Sem cidades com dados de venda.</div>}
          </div>
        </div>
      </div>

      {points.length === 0 && (
        <div className="mt-6 border border-[#DDA7A5] bg-[#F4E6E5] p-4 text-sm">
          <strong>Sem pontos no mapa ainda.</strong> Os pontos sao registrados quando o cliente assina a promissoria digital com a geolocalizacao ativada.
        </div>
      )}
    </div>
  );
}
